import React from 'react';
import { m2RangeToFt2Range } from '../../utils/m2toft2';
import Icon, { IconTypes } from '../generic/Icon';
import styles from './index.module.scss';

export default function PeopleAndSize({ numberOfSeats, physicalSizeM2 }) {
  let showIconRow = Boolean(numberOfSeats) || Boolean(physicalSizeM2);
  if (!showIconRow) {
    return null;
  }
  return (
    <div className={styles.peopleAndSize}>
      {numberOfSeats && (
        <div className={styles.seating}>
          <Icon
            IconType={IconTypes.people}
            label={`${numberOfSeats} ${numberOfSeats === '1' ? 'person' : 'people'} `}
          />
        </div>
      )}
      {physicalSizeM2 && (
        <div className={styles.size}>
          <Icon IconType={IconTypes.size} label={`${physicalSizeM2}m² / ${m2RangeToFt2Range(physicalSizeM2)}ft²`} />
        </div>
      )}
    </div>
  );
}
